// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import apiFun from "@/http/api.js";
// 引入 我们准备好的 store
import store from '@/store/index.js'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUI);
import  "amfe-flexible";
import Vant from 'vant';
import 'vant/lib/index.css';
import './theme-premium.css';
Vue.use(Vant);

// 全局注册
Vue.prototype.$apiFun = apiFun;//请求接口api

Vue.config.productionTip = false

// 记录各页离开时的滚动位置，用于返回 keep-alive 页面时还原（避免每次回首页都弹回顶部）
var pageScrollMap = {};
router.afterEach((to, from, next) => {
  var keep = to.matched.some(function (r) {
    return r.meta && r.meta.keepAlive;
  });
  if (keep && pageScrollMap[to.fullPath] != null) {
    // keep-alive 页面 DOM 已缓存，等重新插入后还原滚动位置
    var y = pageScrollMap[to.fullPath];
    Vue.nextTick(function () {
      requestAnimationFrame(function () {
        window.scrollTo(0, y);
      });
    });
  } else {
    window.scrollTo(0, 0); //新页面/首次进入 keep-alive 页面：回到顶部
    if (document.querySelector('.index-page')) {
      document.querySelector('.index-page').scrollTo(0, 0);
    }
  }
});
// 路由改成按需加载后多了一个失败模式：弱网下分包没拉下来，vue-router
// 不会重试，用户就卡在空白页。这里兵不血刃地刷一次（重新拿 index.html +
// 重新请求分包），并用 sessionStorage 打标防死循环 —— 如果刷完还是拉不到，
// 就不再刷了，否则网络真的断了会变成无限刷新。
router.onError(function (err) {
  var msg = (err && err.message) || '';
  if (!/Loading( CSS)? chunk \S* failed/i.test(msg)) {
    return;
  }
  if (sessionStorage.getItem('chunk_reloaded')) {
    return;
  }
  sessionStorage.setItem('chunk_reloaded', '1');
  window.location.reload();
});
router.afterEach(function () {
  // 成功进入新路由就把标清掉，下次再出问题还能救一次
  sessionStorage.removeItem('chunk_reloaded');
});

// ===== 发版自动更新：后台更新前端后，用户无需手动刷新即可拿到新版 =====
// 原理：index.html 里的 app.<hash>.js 每次发版都会变，拿它当版本号。
// 探测到线上 hash 与当前运行的不一致 => 标记待升级，在「切路由 / 切回标签页」
// 这种自然时机整页 reload（绝不在用户当前页操作中途强刷，避免打断）。
(function () {
  var RUN_VER = (function () {
    var ss = document.getElementsByTagName('script');
    for (var i = 0; i < ss.length; i++) {
      var m = (ss[i].src || '').match(/app\.[a-f0-9]+\.js/);
      if (m) return m[0];
    }
    return null;
  })();
  var needUpgrade = false;
  function checkVer() {
    fetch('/index.html?_=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var m = html.match(/app\.[a-f0-9]+\.js/);
        if (!m) return;
        if (RUN_VER === null) { RUN_VER = m[0]; return; } // 兜底：拿不到运行版本就以首探为准
        if (m[0] !== RUN_VER) { needUpgrade = true; }
      })
      .catch(function () {});
  }
  checkVer();
  setInterval(checkVer, 5 * 60 * 1000);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      if (needUpgrade) { needUpgrade = false; window.location.reload(); }
      else { checkVer(); }
    }
  });
  router.afterEach(function () {
    if (needUpgrade) { needUpgrade = false; window.location.reload(); }
  });
})();

router.beforeEach((to, from, next) => {
  // 离开当前页前保存其滚动位置
  pageScrollMap[from.fullPath] = window.scrollY || document.documentElement.scrollTop || 0;
  let token = localStorage.getItem('token') ? localStorage.getItem('token') : '';
  if (to.matched.some(res => res.meta.requireAuth)) { // 验证是否需要登陆
    if (localStorage.getItem('token')) { // 查询本地存储信息是否已经登陆
      next();
    } else {
      next({
        path: '/login', // 未登录则跳转至login页面
        query: { redirect: to.fullPath } // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
      });
    }
  } else {
    next();
  }


});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,//使用store
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js